import { useCallback } from "react";
import { useSurvey } from "../../../../../common/hooks/api/useSurvey";
import { OrganizationPublicId } from "../../../../../common/service/server/Types";

// Org-scoped UI state for the Data Flows recommendation surfaces, stored through the
// generic org-survey store (the OrgSurveyController accepts arbitrary survey names and
// interceptors are name-gated, so this needs no backend). useProgressKeys — which
// pol-7592 used for the same job — was removed by pol-7677.
export const DATA_FLOWS_UI_SURVEY_NAME = "data-flows-ui-state";

export const PURPOSES_RECOMMENDATIONS_DISMISSED_SLUG = "purposes-recommendations-dismissed";

export function useRecommendationDismissal(orgId: OrganizationPublicId, slug: string) {
  const { answers, setAnswer, request } = useSurvey(orgId, DATA_FLOWS_UI_SURVEY_NAME);

  const dismiss = useCallback(() => {
    // Fire-and-forget: local pending state hides the card immediately.
    void setAnswer(slug, "true");
  }, [setAnswer, slug]);

  return {
    // Wait for answers before showing a dismissible card, so users who already
    // dismissed it never see it flash on load.
    loaded: request.success,
    dismissed: answers?.[slug] === "true",
    dismiss,
  };
}
